import { useLoad } from "@redotech/react-util/load";
import { useTranslation } from "@redotech/redo-i18n";
import { RedoConversionRpcClientContext } from "@redotech/redo-merchant-app-common/redo-conversion-rpc-client-provider";
import { ShippingOptionsCheckoutPreview } from "@redotech/redo-web-conversion/checkouts/shipping/shipping-options-checkout-preview";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";
import * as css from "./checkout-experience-node.module.css";

/** Shows the shipping methods configured for a checkout experience. */
export const CheckoutExperienceShippingHover = memo(
  function CheckoutExperienceShippingHover({
    checkoutExperienceId,
  }: {
    checkoutExperienceId: string | undefined;
  }) {
    const { t } = useTranslation();
    const conversionRpcClient = useContext(RedoConversionRpcClientContext);

    const experienceLoad = useLoad(
      async (signal) => {
        if (!conversionRpcClient || !checkoutExperienceId) {
          return undefined;
        }
        return conversionRpcClient.getCheckoutExperienceById(
          { checkoutExperienceId },
          { signal },
        );
      },
      [conversionRpcClient, checkoutExperienceId],
    );

    if (experienceLoad.pending && experienceLoad.value === undefined) {
      return (
        <Text fontSize="xs" textColor="secondary">
          {t("Loading shipping methods…")}
        </Text>
      );
    }

    const rateTables = experienceLoad.value?.rateTables ?? [];

    if (rateTables.length === 0) {
      return (
        <Text fontSize="xs" textColor="secondary">
          {t("No shipping methods configured.")}
        </Text>
      );
    }

    return (
      <div className={css.shippingHoverPreview}>
        <ShippingOptionsCheckoutPreview rateTables={rateTables} />
      </div>
    );
  },
);
